import * as React from 'react';

import { ILocation } from '../../../../api/locations';
import { addPikAdfoxBanner } from '../../../../serp/components/adfox/index';
import { IMakeRequest } from '../../../../utils/request';
import { Row } from '../markup';

const style = require('./index.css');

export function renderPickBanner(
  title: string,
  buttons: React.ReactNode,
  currentLocation: ILocation | 'moscow_mo' | 'spb_lo',
  makeRequest: IMakeRequest,
) {
  let locationId: number;

  if (currentLocation === 'moscow_mo') {
    locationId = 1;
  } else if (currentLocation === 'spb_lo') {
    locationId = 2;
  } else {
    locationId = currentLocation.parentId || currentLocation.id;
  }

  return (
    <Row title={title}>
      <div className={style['containerWrapper']}>
        <div className={style['rawsWrapper']}>{buttons}</div>
        {addPikAdfoxBanner(locationId, makeRequest)}
      </div>
    </Row>
  );
}
